import { clone } from 'lodash';

import actions from '../constants';

import { convertContactToProfile } from './profile_helpers';

const initialState = {
  continueStatus: 'unsaved',
  error: {},
  profile: {},
  contactId: '',
  profileUpdated: false
};

const profile = function(state = initialState, action) {
  switch(action.type) {
    case actions.INITIALIZE_PROFILE:
      return {
        ...state,
        contactId : action.contact.id,
        profile: convertContactToProfile(action.contact)
      }
    case actions.PROFILE_CHANGE:
      let updatedProfile = clone(state.profile);
      updatedProfile[action.key] = action.value;
      return {
        ...state,
        profile: updatedProfile,
        continueStatus: 'unsaved',
        profileUpdated: true
      };
    case actions.PROFILE_SAVING:
      return {
        ...state,
        continueStatus: 'saving',
        error: {}
      };
    case actions.PROFILE_SAVED:
      return {
        ...state,
        continueStatus: 'saved'
      };
    case actions.PROFILE_UNSAVED:
      return {
        ...state,
        continueStatus: 'unsaved'
      };
    case actions.PROFILE_SAVE_ERROR:
      return {
        ...state,
        continueStatus: 'error',
        error: action.error
      };
    default:
      return state;
  }
};

export default profile;



// WEBPACK FOOTER //
// ./src/advocate/onboarding/reducers/profile.js